import { Status } from '#api/shared/@types/generated/backend/graphql-schema-types'

const IS_GAME_ROUTE_FALLBACK = '/'

export default defineNuxtRouteMiddleware(async (_, from) => {
  if (import.meta.server) return // fallback if route is not ssr: false in nuxt.config routeRules
  const { navigateToLocalized } = useRouterUtils()

  const payload = await useUserStatusLazyQuery({
    fetchPolicy: 'cache-first',
  }).load()

  const status = payload && payload?.player?.status

  if (from.meta.isGameRoute && status === Status.Verified) {
    return navigateToLocalized(IS_GAME_ROUTE_FALLBACK)
  }
})
